import React, { useEffect, useState } from 'react'

import { styled } from '@mui/material/styles'
import { DEADLINE_WARNING_THRESHOLD_MINUTES } from '../../constants/DeadlineSettings'

export interface IOwnProps {
    acceptedDeadline: Date | null
    className?: string
}

export type IProps = IOwnProps

const AcceptedTime: React.FC<IProps> = (props) => {
    const { acceptedDeadline, className } = props
    const [timeLeft, setTimeLeft] = useState<string | null>(null)
    const [isUrgent, setIsUrgent] = useState<boolean>(false)

    useEffect(() => {
        if (!acceptedDeadline) return

        const updateCountdown = () => {
            const now = new Date()
            const timeDiff = acceptedDeadline.getTime() - now.getTime()

            if (timeDiff <= 0) {
                setTimeLeft(null)
                setIsUrgent(false)
                return
            }

            setIsUrgent(timeDiff <= DEADLINE_WARNING_THRESHOLD_MINUTES * 60 * 1000)

            const hours = Math.floor(timeDiff / (1000 * 60 * 60))

            if (hours > 24) {
                const daysCount = Math.floor(hours / 24)
                const title = daysCount === 1 ? 'day' : 'days'
                setTimeLeft(`${daysCount} ${title}`)
                return
            }

            const minutes = Math.floor(
                (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
            )

            const formattedHours = hours.toString().padStart(2, '0')
            const formattedMinutes = minutes.toString().padStart(2, '0')

            setTimeLeft(`${formattedHours}:${formattedMinutes}`)
        }

        updateCountdown()
        const interval = setInterval(updateCountdown, 60000)

        return () => clearInterval(interval)
    }, [acceptedDeadline])

    return (
        <Label className={className} $urgent={isUrgent}>
            {!!acceptedDeadline && !!timeLeft ? (
                <>Time&nbsp;to&nbsp;accept&nbsp;{timeLeft}</>
            ) : (
                ''
            )}
        </Label>
    )
}

const Label = styled('span', {
    shouldForwardProp: (prop) => prop !== '$urgent',
})<{ $urgent: boolean }>(({ $urgent }) => ({
    fontSize: 12,
    fontWeight: 400,
    color: $urgent ? 'red' : 'blue',
}))

export default AcceptedTime
